<template>
    <main-panel v-if=" $route.params.path==null">
        <template v-slot:header>
            <h2>{{$route.name}}</h2>
        </template>
        <div class="oversight">
            <component 
                v-for = "item in skeleton" 
                :key="item" 
                :admin="admin"
                :is="item.component_name"
                :type-tols="item.component_name"
                :params="item.params"
                :header="item.header"
                :url="item.url"/> 
        </div>
    </main-panel>
</template>
<script>
import axios from 'axios';
import mainPanel from '../components/main/mainPanel.vue';
import components from '@/mixins/components.mixin.js';
export default{
    mixins:[components],
    components:{
        mainPanel,
    },
    mounted(){
        this.getSkeleton(this.$route.fullPath.substring(1))
        axios
            .get("https://mosp51.ru/api/login")
            .then(response=>{
                 console.log( response.data,'username')
                if (response.data.username){
                    this.admin = true
                } else {
                    this.admin = false
                }
            })
    },
    methods:{

    },
    data(){
        return{
            admin:false
        }
    }
}
</script>
<style>
.oversight section:last-child{
    margin-bottom: 100px;
}
.oversight {
    margin-top: 48px;
}
</style>